module.exports = __webpack_public_path__ + "c1bec130cac5ce10de30693c4a292ddc.png";